import { Link } from 'react-router-dom'

import { useOutbox } from '@carrent/core'
import { Icon } from '@carrent/ui'

/**
 * Индикатор очереди.
 *
 * Показывается только когда есть что показать: постоянная плашка
 * «всё отправлено» превращается в шум, который перестают замечать —
 * включая тот момент, когда она сменится на «не отправлено».
 */
export function QueueIndicator() {
  const { count, failed, online } = useOutbox()

  if (count === 0) return null

  const hasFailed = failed.length > 0

  return (
    <Link
      to="/queue"
      className={`queue-indicator ${hasFailed ? 'queue-indicator--failed' : ''}`}
      aria-live="polite"
    >
      <Icon name={hasFailed ? 'warning' : 'trips'} size={16} />
      <span className="queue-indicator__text">
        {hasFailed
          ? `${failed.length} не отправлено`
          : `${count} ожидают отправки`}
      </span>
      {!online && <span className="queue-indicator__offline">нет сети</span>}
      <Icon name="chevronRight" size={14} className="queue-indicator__chevron" />
    </Link>
  )
}
